import { render, staticRenderFns } from "./AdminComplianceAutomation.vue?vue&type=template&id=545598e5&scoped=true"
import script from "./AdminComplianceAutomation.vue?vue&type=script&lang=js"
export * from "./AdminComplianceAutomation.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AdminComplianceAutomation.vue?vue&type=style&index=1&id=545598e5&prod&lang=css"
import style2 from "./AdminComplianceAutomation.vue?vue&type=style&index=2&id=545598e5&prod&scoped=true&lang=css"
import style3 from "./AdminComplianceAutomation.vue?vue&type=style&index=3&id=545598e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545598e5",
  null
  
)

export default component.exports